import { MobileApplicationAppConfig } from '../../types';

export const mobileApplicationAppConfig: MobileApplicationAppConfig = {
  androidApkUrl: 'https://storage.googleapis.com/static-content-lvbetcom-new/bcf-twa/lvbetpl/lvbetpl.apk',
  iosStoreUrl: 'https://apps.apple.com/pl/app/lv-bet-sports-betting/id6473729287'
};
